import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React, { useState } from 'react';
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/home";
import ProductsIndex from "./pages/Products/ProductsIndex/productsIndex";
import Arta from "./pages/Products/Arta/arta";
import Argos from "./pages/Products/Argos/argos";
import Eyepal from "./pages/Products/Eyepal/eyepal";
import Glaucoma from "./pages/Products/Glaucoma/glaucoma";
import Strabismus from "./pages/Products/Strabismus/strabismus";
import CompanyNews from "./pages/CompanyNews/companyNews";
import Contract from "./pages/NewsInfo/Contract/contract";
import AmblyopiaClinical from "./pages/NewsInfo/AmblyopiaClinical/amblyopiaClinical";
import Academic from "./pages/NewsInfo/Academic/academic";
import Pre from "./pages/NewsInfo/Pre-A/pre-a";
import BestEnterprise from "./pages/NewsInfo/BestEnterprise/bestEnterprise";
import Invest from "./pages/NewsInfo/Invest/invest";
import Arvo from "./pages/NewsInfo/Arvo/arvo";
import FCST from "./pages/Fcst/FcstIndex/fcstIndex";
import BreakthroughTheory from "./pages/Fcst/LiteratureInfo/breakthroughTheory";
import BreakthroughMethod from "./pages/Fcst/LiteratureInfo/breakthroughMethod";
import IdentifyAmblyopia from "./pages/Fcst/SciencePopularizationInfo/identifyAmblyopia";
import IdentifyMyopia from "./pages/Fcst/SciencePopularizationInfo/identifyMyopia";
import AboutUs from "./pages/AboutUs/aboutUs";

export default function App() {
  const [headerDark, setHeaderDark] = useState(false);
  return (
    <BrowserRouter>
      <div className='App'>
        <Header dark={headerDark} />
        <Routes>
          <Route exact path="/" element={<Home setHeaderDark={setHeaderDark} key="home"/>} />
          <Route exact path="/productsIndex" element={<ProductsIndex setHeaderDark={setHeaderDark} key="productsIndex"/>} />
          <Route exact path="/arta" element={<Arta setHeaderDark={setHeaderDark} />} />
          <Route exact path="/argos" element={<Argos setHeaderDark={setHeaderDark} />} />
          <Route exact path="/eyepal" element={<Eyepal setHeaderDark={setHeaderDark} />} />
          <Route exact path="/glaucoma" element={<Glaucoma setHeaderDark={setHeaderDark} />} />
          <Route exact path="/strabismus" element={<Strabismus setHeaderDark={setHeaderDark} />} />
          <Route exact path="/companyNews" element={<CompanyNews setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/contract" element={<Contract setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/amblyopiaClinical" element={<AmblyopiaClinical setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/academic" element={<Academic setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/pre" element={<Pre setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/bestEnterprise" element={<BestEnterprise setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/invest" element={<Invest setHeaderDark={setHeaderDark} />} />
          <Route exact path="/newsInfo/arvo" element={<Arvo setHeaderDark={setHeaderDark} />} />
          <Route exact path="/fcst" element={<FCST setHeaderDark={setHeaderDark} />} />
          <Route exact path="/fcst/breakthroughTheory" element={<BreakthroughTheory setHeaderDark={setHeaderDark} />} />
          <Route exact path="/fcst/breakthroughMethod" element={<BreakthroughMethod setHeaderDark={setHeaderDark} />} />
          <Route exact path="/fcst/identifyAmblyopia" element={<IdentifyAmblyopia setHeaderDark={setHeaderDark} />} />
          <Route exact path="/fcst/identifyMyopia" element={<IdentifyMyopia setHeaderDark={setHeaderDark} />} />
          <Route exact path="/aboutUs" element={<AboutUs setHeaderDark={setHeaderDark} />} />
        </Routes>
        {/* <Footer /> */}
      </div>
    </BrowserRouter>
  );
}